<template>
  <!-- 个人介绍 -->
  <base-panel :title="title" :hide-button="true" class="panel-wrapper">
    <slot>
      <div class="description">
        {{ description }}
      </div>
    </slot>
  </base-panel>
</template>

<script>
import BasePanel from '@/components/BasePanel/BasePanel'
export default {
  name: 'PersonalDescriptionPanel',
  components: { BasePanel },
  props: {
    title: {
      type: String,
      required: false,
      default: '个人介绍'
    },
    description: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.panel-wrapper {
  margin-top: 30px;
  min-height: 220px;
}

.description {
  padding: 10px 20px;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 1px;
  color: #262626;
}
</style>
